import { api } from "./api";
import type { SupportError } from "./supportContext";
export type SupportKind = "nesto_ne_radi" | "ne_znam_kako" | "prijedlog";
export type SupportStatus = "novo" | "u_radu" | "rijeseno";
export interface SupportRequest {
  mail_delivered?: boolean;
  id: string;
  number: number;
  created_at: string;
  user_id: string;
  user_name: string;
  role: string;
  kind: SupportKind;
  text: string;
  screen_name: string;
  url: string;
  user_agent: string;
  last_error: SupportError | null;
  status: SupportStatus;
  answer: string | null;
  answered_by: string | null;
  answered_at: string | null;
  resolved_at: string | null;
  add_to_faq: boolean;
  photos: { id: string; filename: string }[];
  events: { id: string; created_at: string; text: string }[];
}
export const supportKinds: {
  value: SupportKind;
  label: string;
  icon: string;
  hint: string;
}[] = [
  {
    value: "nesto_ne_radi",
    label: "Nešto ne radi",
    icon: "⚠️",
    hint: "Gumb, ekran ili podatak nije kako treba",
  },
  {
    value: "ne_znam_kako",
    label: "Ne znam kako",
    icon: "❓",
    hint: "Pitanje kako nešto napraviti",
  },
  {
    value: "prijedlog",
    label: "Prijedlog",
    icon: "💡",
    hint: "Ideja kako da bude lakše",
  },
];
export const supportStatuses: Record<SupportStatus, string> = {
  novo: "Novo",
  u_radu: "U radu",
  rijeseno: "Riješeno",
};
export interface SupportRecipient {
  id: string;
  full_name: string;
  role: string;
}
export const support = {
  list: async () => (await api.get<SupportRequest[]>("/support")).data,
  get: async (id: string) =>
    (await api.get<SupportRequest>(`/support/${id}`)).data,
  create: async (body: FormData) =>
    (await api.post<SupportRequest>("/support", body)).data,
  update: async (
    id: string,
    data: { status?: SupportStatus; answer?: string; add_to_faq?: boolean },
  ) => (await api.patch<SupportRequest>(`/support/${id}`, data)).data,
  forward: async (id: string, user_id: string, message: string) =>
    (
      await api.post<SupportRequest>(`/support/${id}/forward`, {
        user_id,
        message,
      })
    ).data,
  recipients: async () =>
    (await api.get<SupportRecipient[]>("/support/recipients")).data,
  settings: async () =>
    (await api.get<{ email: string | null }>("/support/settings")).data,
  saveSettings: async (email: string | null) =>
    (await api.patch<{ email: string | null }>("/support/settings", { email }))
      .data,
  photo: async (request: string, id: string) =>
    (
      await api.get<Blob>(`/support/${request}/photos/${id}`, {
        responseType: "blob",
      })
    ).data,
};
export function supportDate(value: string) {
  return new Intl.DateTimeFormat("hr-HR", {
    timeZone: "Europe/Zagreb",
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}
